module.exports = __webpack_public_path__ + "static/img/kukai_header.d1af0bc2.png";